var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4375 2.25C15.6284 2.25 16.6031 3.17516 16.6823 4.34595L16.6875 4.5V6.5C16.6875 6.91421 16.3517 7.25 15.9375 7.25C15.5578 7.25 15.244 6.96785 15.1943 6.60177L15.1875 6.5V4.5C15.1875 4.1203 14.9053 3.80651 14.5393 3.75685L14.4375 3.75H9.5625C9.1828 3.75 8.86901 4.03215 8.81935 4.39823L8.8125 4.5V6.5C8.8125 6.91421 8.47671 7.25 8.0625 7.25C7.6828 7.25 7.36901 6.96785 7.31935 6.60177L7.3125 6.5V4.5C7.3125 3.30914 8.23766 2.33436 9.40845 2.25519L9.5625 2.25H14.4375Z",
    fill: "#D05952"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20228 5.75225C5.58086 5.72312 5.91537 5.98038 5.99296 6.34157L6.00759 6.44251L6.96316 18.8651C7.01974 19.6006 7.60031 20.1784 8.32187 20.2439L8.45872 20.25H13.1716C13.5858 20.25 13.9216 20.5858 13.9216 21C13.9216 21.3797 13.6394 21.6935 13.2734 21.7432L13.1716 21.75H8.45872C6.95141 21.75 5.68845 20.6342 5.48665 19.1588L5.46758 18.9801L4.51201 6.55756C4.48024 6.14456 4.78929 5.78401 5.20228 5.75225Z",
    fill: "#D05952"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.75C20.4142 5.75 20.75 6.08579 20.75 6.5C20.75 6.8797 20.4678 7.19349 20.1018 7.24315L20 7.25H4C3.58579 7.25 3.25 6.91421 3.25 6.5C3.25 6.1203 3.53215 5.80651 3.89823 5.75685L4 5.75H20Z",
    fill: "#D05952"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.696 5.75195L18.798 5.75293C19.1765 5.78205 19.4678 6.08744 19.4892 6.45625L19.4882 6.55825L18.9443 13.6292C18.9125 14.0422 18.552 14.3513 18.139 14.3195C17.7604 14.2904 17.4692 13.985 17.4478 13.6162L17.4487 13.5142L17.9927 6.4432C18.0218 6.06462 18.3272 5.77339 18.696 5.75195Z",
    fill: "#D05952"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 17.5C10.75 14.6005 13.1005 12.25 16 12.25C18.8995 12.25 21.25 14.6005 21.25 17.5C21.25 20.3995 18.8995 22.75 16 22.75C13.1005 22.75 10.75 20.3995 10.75 17.5ZM19.75 17.5C19.75 15.4289 18.0711 13.75 16 13.75C13.9289 13.75 12.25 15.4289 12.25 17.5C12.25 19.5711 13.9289 21.25 16 21.25C18.0711 21.25 19.75 19.5711 19.75 17.5Z",
    fill: "#D05952"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2197 15.7197C14.4859 15.4534 14.9026 15.4292 15.1962 15.6471L15.2803 15.7197L17.7803 18.2197C18.0732 18.5126 18.0732 18.9874 17.7803 19.2803C17.5141 19.5466 17.0974 19.5708 16.8038 19.3529L16.7197 19.2803L14.2197 16.7803C13.9268 16.4874 13.9268 16.0126 14.2197 15.7197Z",
    fill: "#D05952"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7197 15.7197C17.0126 15.4268 17.4874 15.4268 17.7803 15.7197C18.0466 15.9859 18.0708 16.4026 17.8529 16.6962L17.7803 16.7803L15.2803 19.2803C14.9874 19.5732 14.5126 19.5732 14.2197 19.2803C13.9534 19.0141 13.9292 18.5974 14.1471 18.3038L14.2197 18.2197L16.7197 15.7197Z",
    fill: "#D05952"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.3824b31b200ef9452828ea5da2e49816.svg";
export { ForwardRef as ReactComponent };